const TOP_BAR_HEIGHT_DEFAULT = 56;
function calculateIframeHeight() {
  return heightToPx(window.innerHeight);
}
function getTopBarHeight() {
  const element = document.getElementById("content");
  const cssValue = getComputedStyle(element).getPropertyValue("padding-top");
  return parseInt(cssValue, 10) || TOP_BAR_HEIGHT_DEFAULT;
}
function heightToPx(height) {
  const topBarHeight = getTopBarHeight();
  return `${height - topBarHeight}px`;
}

export { TOP_BAR_HEIGHT_DEFAULT, calculateIframeHeight, getTopBarHeight, heightToPx };
